import * as Yup from 'yup';

export const ResetPasswordSchema = Yup.object({
    password: Yup.string().trim().required('This field is required'),
    confirmPassword: Yup.string()
        .required('This field is required')
        .when('password', {
            is: (val: any) => (val && val.length > 0 ? true : false),
            then: Yup.string()
                .trim()
                .oneOf([Yup.ref('password')], 'Passwords do not match'),
        }),
});
